import React from 'react';
import './product-tabs.scss';

const ProductTabs: React.FC = ({ children }) => (
    <div className="product-tabs">
        {children}
    </div>
);

export default ProductTabs;
